import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { Observable } from 'rxjs';
import { OAuthModule } from 'angular-oauth2-oidc';
import {
  AnchorModule,
  ConnectedOverlayModule,
  HeaderModule,
  IconModule,
  ListModule,
  TextComponent,
} from '@virginmediao2/momentum-angular';
import type { LoginContentModel } from '@/shared/interfaces';
import { StrapiCoreService } from '@/shared/services/strapi-core.service';
import { AuthService } from '@/shared/services/auth.service';
import { TokenService } from '@/shared/services/token.service';

@Component({
  selector: 'vm-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: true,
  imports: [
    HeaderModule,
    AnchorModule,
    CommonModule,
    NgOptimizedImage,
    OAuthModule,
    ConnectedOverlayModule,
    IconModule,
    ListModule,
    TextComponent,
  ],
  encapsulation: ViewEncapsulation.None,
})
export class HeaderComponent implements OnInit {
  loginContent$: Observable<LoginContentModel>;
  isAuthenticated = false;
  headerLogo = {
    logoAlt: 'Virgin Media',
    logoHref: 'https://www.virginmedia.com/ ',
    logoAsset: '/uploads/white_3x_956e633d70.png',
  };

  constructor(
    private strapiCoreService: StrapiCoreService,
    private tokenService: TokenService,
    private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.loginContent$ = this.strapiCoreService.getLoginContent();

    const checkAuthInterval = setInterval(() => {
      if (this.authService.isAuthenticated()) {
        clearTimeout(redirectToAppStart);
        clearInterval(checkAuthInterval);
        this.isAuthenticated = true;
      }
    }, 100);

    const redirectToAppStart = setTimeout(() => {
      clearInterval(checkAuthInterval);
      clearTimeout(redirectToAppStart);
    }, 505);
  }

  onLoginClick() {
    this.authService.redirectToLogin();
  }

  onLogoutClick() {
    this.tokenService.removeAuthTokenFromStorage();
    sessionStorage.removeItem('vmo2_sess_conversation_ID');
    sessionStorage.removeItem('vmo2_zeus_session');
    this.authService.logout();
    this.router.navigate(['/'], { relativeTo: this.route });
  }
}
